<!--相关推荐-->
<template>
    <div class="recommend" v-if="list && list.length >= 1">
        <div class="recommend-title">相关推荐</div>
        <div class="recommend-list">
            <div :key="index" v-for="(item,index) in list" class="recommend-item" v-on:click="onDownClick()">
                <div class="recommend-item-cover">
                    <img :src="`/api/resource/resource/resource/download/${getCoverImage(item.cover,item.resource)}`"
                         alt="">
                    <div class="recommend-item-cover-modal"></div>
                    <div class="recommend-item-cover-time">
                        <img src="../../../assets/images/common/player.svg" alt="">
                        <span>{{secondToDate(item.duration)}}</span>
                    </div>
                </div>
                <p class="recommend-item-open-info">
                    打开足趣社区
                </p>
                <p class="recommend-item-open-title">
                    {{item.note}}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // 下载按钮点击事件
            onDownClick: [Function],
            // 集合数据
            list: [Array],
        },
        methods: {
            // 秒转化成 时分秒
            secondToDate: (second) => {
                let h = Math.floor(second / 3600);
                h = !h ? 0 : h;
                h = h <= 9 ? "0" + h : h;
                let m = Math.floor((second / 60 % 60)) ?? 0;
                m = !m ? 0 : m;
                m = m <= 9 ? "0" + m : m;
                let s = Math.floor((second % 60)) ?? 0;
                s = !s ? 0 : s;
                s = s <= 9 ? "0" + s : s;
                return h + ":" + m + ":" + s;
            },
            // 获得封面图片(有封面就直接用封面，否则用视频转换)
            getCoverImage(cover, resource) {
                return cover ?? (resource + "?imgStyleName=gif");
            }
        },
    }
</script>

<style scoped>
    .recommend {
        padding: 14px;
    }

    .recommend-title {
        font-size: 18px;
        color: #323232;
        margin-bottom: 19px;
    }

    .recommend-list {
        margin: 0 -5px;
    }

    .recommend-item {
        display: inline-block;
        margin: 5px;
        width: calc(50% - 10px);
    }

    .recommend-item-cover {
        height: 95px;
        position: relative;
        border-radius: 5px;
        overflow: hidden;
    }

    .recommend-item-cover img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .recommend-item-cover-modal {
        background: rgba(0, 0, 0, 0.1);
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
    }

    .recommend-item-cover-time {
        position: absolute;
        bottom: 10px;
        right: 10px;
        color: #FFF;
        font-size: 11px;
    }

    .recommend-item-cover-time img {
        width: 10px;
        margin-right: 5px;
    }

    .recommend-item-open-info {
        color: #ff4a2d;
        margin: 5px 3px 2px;
    }

    .recommend-item-open-title {
        font-size: 16px;
        height: 45px;
        line-height: 22px;
        color: #262626;
        letter-spacing: 0;
        text-align: justify;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
</style>
